import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import AjaxPlugin from './plugins/ajax'
import jsPlumb from 'jsplumb'
import App from './App'
import CommonComponent from '@/components/page/components/CommonComponent'
import CommonTextComponent from '@/components/page/components/CommonTextComponent'
import PcRowComponent from '@/components/page/components/PcRowComponent'
import PcColComponent from '@/components/page/components/PcColComponent'
import MobileViewBoxComponent from '@/components/page/components/MobileViewBoxComponent'
import VuxTabpanelComponent from '@/components/page/components/VuxTabpanelComponent'

require('es6-promise').polyfill()

Vue.use(ElementUI)
Vue.use(AjaxPlugin)
Vue.component(CommonComponent.name, CommonComponent)
Vue.component(CommonTextComponent.name, CommonTextComponent)
Vue.component(PcRowComponent.name, PcRowComponent)
Vue.component(PcColComponent.name, PcColComponent)
Vue.component(MobileViewBoxComponent.name, MobileViewBoxComponent)
Vue.component(VuxTabpanelComponent.name, VuxTabpanelComponent)

jsPlumb.jsPlumb.ready(function () {
  console.log('jsPlumb is ready')
})

Vue.config.productionTip = false

let info = sessionStorage.getItem('admin')
if (info) {
  store.commit('admin', JSON.parse(info))
} else {
  router.push({ path: '/login' })
}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
